<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">event</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Alterar data de fabricação/validade</h2>
    <span class="modal-subtitle">Lote: {{ data.numeroLote }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" [disabled]="loading" (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <div class="form-grid">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Data de fabricação</mat-label>
      <input matInput [matDatepicker]="pickerFabricacao" [(ngModel)]="novaDataFabricacao" (input)="onDateInput($event)"
        (keydown)="onDateKeydown($event)" (blur)="onDataFabricacaoBlur($event)" placeholder="DD/MM/AAAA"
        inputmode="numeric" maxlength="10" [max]="hoje" />
      <mat-datepicker-toggle matIconSuffix [for]="pickerFabricacao"></mat-datepicker-toggle>
      <mat-datepicker #pickerFabricacao></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Data de validade</mat-label>
      <input matInput [matDatepicker]="pickerValidade" [(ngModel)]="novaDataValidade" (input)="onDateInput($event)"
        (keydown)="onDateKeydown($event)" (blur)="onDataValidadeBlur($event)" placeholder="DD/MM/AAAA"
        inputmode="numeric" maxlength="10" [min]="novaDataFabricacao" />
      <mat-datepicker-toggle matIconSuffix [for]="pickerValidade"></mat-datepicker-toggle>
      <mat-datepicker #pickerValidade></mat-datepicker>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" type="button" [disabled]="loading" (click)="fechar()">
    Cancelar
  </button>
  <button mat-flat-button class="btn-primary" type="button" [disabled]="!podeSalvar" (click)="salvar()">
    @if (loading) { <mat-spinner diameter="20"></mat-spinner> }
    @else { <span>Salvar</span> }
  </button>
</mat-dialog-actions>
